<template>
  <v-container fluid>
    <v-form ref="form" v-model="valid" :lazy-validation="lazy">
      <v-text-field
        v-model="name"
        :rules="nameRules"
        :counter="50"
        label="Nombre"
        required
      ></v-text-field>
      <v-text-field
        v-model="lastname"
        :rules="lastnameRules"
        :counter="50"
        label="Apellidos"
        required
      ></v-text-field>
      <v-text-field
        v-model="email"
        :rules="emailRules"
        label="E-mail"
        required
      ></v-text-field>
      <v-text-field
        v-model="nif"
        :rules="documentRules"
        label="Número DNI"
        required
      ></v-text-field>
      <v-select
        prepend-icon="create"
        :items="signatureItems"
        label="Tipo de operación"
        v-model="signatureSelected"
        :rules="[v => !!v || 'Debes elegir una opción']"
        required
      ></v-select>
      <v-text-field
        v-if="
          signatureSelected === 'Identificación no asistida y firma' ||
            signatureSelected === 'Identificación y firma Parte Viajero'
        "
        v-model="phone"
        :rules="phoneRules"
        label="Número de móvil"
        required
      ></v-text-field>
      <v-btn
        :disabled="!valid"
        flat
        round
        color="orange darken-4"
        dark
        bold
        outline
        @click="submit"
        >Enviar</v-btn
      >
      <v-btn flat round color="orange darken-4" dark bold outline @click="clear"
        >Borrar</v-btn
      >
    </v-form>
    <v-snackbar
      v-model="isSnackBarVisible"
      :top="true"
      :color="snackBarColor"
      :right="true"
      :timeout="4000"
    >
      {{ snackBarText }}
    </v-snackbar>
    <!-- <v-dialog
      v-model="isVideoIdentificationIframeVisible"
      width="90%"
      :key="forceIframeRendered"
    >
      <v-card>
        <iframe
          style="width:100%"
          height="700px"
          allow="camera; microphone"
          :src="urlIdentificationSignature"
        ></iframe>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            round
            color="orange darken-4"
            dark
            bold
            outline
            @click="closeIframe()"
            >Cerrar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog> -->
  </v-container>
</template>

<script>
import axios from "axios";
import { bodyAut } from "../utils/createLoginAutToken";
//import { body } from "../utils/createJSON";
import { body } from "../utils/createIdentificationJSON";
import { body2 } from "../utils/createParteViajeroJSON";

export default {
  props: ["scrollTop", "signatureType"],
  beforeDestroy() {
    document.body.removeAttribute("class", "noscroll");
    window.scrollTo(0, this.scrollTop);
  },
  data: () => ({
    signatureItems: [
      "Identificación no asistida",
      "Identificación no asistida y firma",
      "Identificación y firma Parte Viajero"
    ],
    signatureSelected: "",
    valid: true,
    lazy: false,
    name: "",
    nameRules: [
      v => !!v || "El nombre es obligatorio",
      v =>
        (v && v.length <= 50) ||
        "El nombre tiene que ser menor de 50 caracteres"
    ],
    lastname: "",
    lastnameRules: [
      v => !!v || "Los apellidos son obligatorios",
      v =>
        (v && v.length <= 50) ||
        "Los apellidos tienen que ser menor de 50 caracteres"
    ],
    email: "",
    emailRules: [
      v => !!v || "El correo electrónico es obligatorio",
      v =>
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          v
        ) || "Introduce una dirección de correo electrónico válida"
    ],
    nif: "",
    documentRules: [
      v => !!v || "El número de identidad es obligatorio"
      // v => /^[0-9\][A-Z]{9,12}$/.test(v) || "Id. document number must be valid"
    ],
    phone: "",
    phoneRules: [
      v => !!v || "El teléfono es requerido",
      v =>
        /^[0-9\-+]{9,15}$/.test(v) || "Introduce un número de teléfono válido"
    ],
    snackBarColor: "",
    snackBarText: "",
    isSnackBarVisible: false,
    isVideoIdentificationIframeVisible: false,
    urlIdentificationSignature: "",
    forceIframeRendered: 0
  }),
  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        this.$ga.event({
          eventCategory: "VideoIdentification", // str
          eventAction: "click", // str
          eventLabel: "CreateButton", // str
          eventValue: 0 // int
        });
        console.log(this.signatureSelected);
        // Native form submission is not yet supported
        axios
          .post(`${process.env.VUE_APP_BASEURL}${"login"}`, {
            username: "jlcl",
            userpassword: "A6xnQhbz4Vx2HuGl4lXwZ5U2I8iziLRFnhP5eNfIRvQ="
          })
          .then(
            success => {
              this.$store.commit("setToken", success.data);
              let bodyData = Object;
              bodyData = JSON.stringify(body2());
              if (
                this.signatureSelected === "Identificación no asistida y firma"
              ) {
                bodyData = JSON.stringify(body());
              }

              if (
                this.signatureSelected ===
                  "Identificación no asistida y firma" ||
                this.signatureSelected ===
                  "Identificación y firma Parte Viajero"
              ) {
                bodyData = bodyData.replace(
                  "##signatureType##",
                  "VIDEO_1PASO_OTP"
                );
              } else {
                bodyData = bodyData.replace(
                  "##signatureType##",
                  "IDENTIFICATION_NO_ASISTIDA"
                );
              }
              bodyData = bodyData.replace("##cellphone##", this.phone);
              bodyData = bodyData.replace("##nif##", this.nif);
              bodyData = bodyData.replace("##resumenif##", "Y");
              bodyData = bodyData.replace("##email##", this.email);
              bodyData = bodyData.replace("##name##", this.name);
              bodyData = bodyData.replace("##lastname##", this.lastname);
              bodyData = JSON.parse(bodyData);

              axios
                .post(
                  `${process.env.VUE_APP_BASEURL}${"create/withotpandtoken/"}${
                    this.$store.getters.domainUuid
                  }`,
                  bodyData
                )
                .then(
                  success => {
                    // this.$store.commit("setESignToken", success.data.loginautToken);
                    this.forceIframeRendered += 1;
                    this.$store.commit(
                      "setOperationUuid",
                      success.data.uuids[0]
                    );
                    this.urlIdentificationSignature = `${"https://videoservices.securyty.com/securyty/identification/#/"}${
                      success.data.uuids[0]
                    }`;
                    this.$refs.form.reset();
                    // this.isVideoIdentificationIframeVisible = true;
                    // window.open(this.urlIdentificationSignature, '_blank');
                    window.location.assign(this.urlIdentificationSignature);
                    // var windowReference = window.open();

                    // myService.getUrl().then(function(url) {
                    //     windowReference.location = url;
                    // });
                    // this.$store.commit("setDocumentUuid", success.data.documentsUuid[0]);
                    // this.getOperation();
                  },
                  () => {
                    this.snackBarColor = "error";
                    this.snackBarText =
                      "Ha ocurrido un error al crear la operación. Por favor, vuelva a intentarlo.";
                    this.isSnackBarVisible = true;
                  }
                );
            },
            () => {
              this.snackBarColor = "error";
              this.snackBarText =
                "Ha ocurrido un error al crear la operación. Por favor, vuelva a intentarlo.";
              this.isSnackBarVisible = true;
            }
          );
      }
    },
    // signatureSelected(item) {
    //   if (item === "Identificación no asistida" || item === "Identificación no asistida y firma") {
    //     this.isSimpleSignature = true;
    //     this.isHandWrittenSignature = false;
    //   } else if (item === "Firma con grafo") {
    //     this.isHandWrittenSignature = true;
    //     this.isSimpleSignature = false;
    //   } else {
    //     this.isSimpleSignature = true;
    //     this.isHandWrittenSignature = false;
    //   }
    // },
    // getOperation() {
    //   axios
    //     .get(
    //       `${process.env.VUE_APP_BASEURL}${"getoperationbyuuid/"}${
    //         this.$store.getters.domainUuid
    //       }${"/"}${this.$store.getters.operationUuid}`
    //     )
    //     .then(
    //       success => {
    //         this.isLoading = false;
    //         this.$store.commit("setOperation", success.data);
    //         success.data.authPolicy.fields.forEach(element => {
    //           if (element.identifier === "cellphone") {
    //             this.$store.commit("setCellphone", element.value);
    //           }
    //           if (element.identifier === "signbox") {
    //             this.$store.commit("setSignBoxName", element.value);
    //           }
    //         });
    //         this.$store.commit("setDocumentUuid", success.data.documents[0].documentUuid);
    //         this.$router.push({ name: "identificationSignature" });
    //       },
    //       () => {
    //         this.snackBarColor = "error";
    //         this.snackBarText =
    //           "Ha ocurrido un error al obtener los datos de la operación. Por favor, vuelve a intentarlo.";
    //         this.isSnackBarVisible = true;
    //       }
    //     );
    // },
    clear() {
      this.$refs.form.reset();
    },
    closeIframe() {
      document.body.removeAttribute("class", "noscroll");
      window.scrollTo(0, this.scrollTop);
      this.isVideoIdentificationIframeVisible = false;
    }
  }
};
</script>
